import pyFormCheckbox from 'pylon-vue/src/components/form-checkbox/form-checkbox';

const sFormCheckbox = {
    name: 'sFormCheckbox',
    extends: pyFormCheckbox,
    props: {
        autocomplete: {
            default: "off"
        }
    }
}

export default sFormCheckbox